import { ActionsUnion } from "../../type/actionsUnion"
import createAction from "../../type/createAction"
import { IPublicHealthStatusDto } from "../../type/healthStatusTypes"
import { StoreState } from "../StoreState"

export type HealthStatusState = Readonly<{
    healthStatuses?: IPublicHealthStatusDto[]
}>
const initialState: HealthStatusState = {}

export const healthStatusReducerActions = {
    setHealthStatuses: (healthStatuses: IPublicHealthStatusDto[]) => createAction("APP/SET_HEALTH_STATUSES", { healthStatuses }),
}

export type HealthStatusActions = ActionsUnion<typeof healthStatusReducerActions>

export const healthStatusReducer = (state: HealthStatusState = initialState, action: HealthStatusActions): HealthStatusState => {
    switch (action.type) {
        case "APP/SET_HEALTH_STATUSES": {
            return {
                ...state,
                healthStatuses: action.healthStatuses,
            }
        }
    }

    return state
}

export const healthStatusSelectors = {
    healthStatuses: (state: StoreState) => state.healthStatus.healthStatuses,
}
